import ClickOutside from '@/utils/directive/click-outside';

export default {
  install (app) {
    app.directive(ClickOutside.name, ClickOutside);
  }
}
